import InsightsTemplate from "./insights-template.js";

export default InsightsTemplate;
